<template>
  <v-card color="transparent" flat>
    <v-card-title>
      <span>
        {{ $t('Dashboard.Documents.header') }}
      </span>
      <v-spacer></v-spacer>
      <v-btn text small @click="showMore = true" color="secondary">{{$t('Global.Action.seeMore')}}</v-btn>
    </v-card-title>
    <v-card-text>
      <v-list color="transparent">
        <v-list-item v-for="document in lastDocuments" :key="document.id" ripple :href="$_file_getDocumentPath(document.id)">
          <v-list-item-avatar>
            <v-icon large>insert_drive_file</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ document.title }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ document.description }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon large>download</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card-text>
    <v-dialog v-model="showMore" max-width="800px" style="overflow-y: none;">
      <v-card height="600px" style="overflow-y: auto;" color="background">
        <v-container>
         <DocumentManager :isPublic="isPublic"/>
        </v-container>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import prettyBytes from 'pretty-bytes'
import FileMixin from '@/mixins/FileMixin'
import { DocumentRepository } from '@portal/api'
import DocumentManager from '@/components/Document/DocumentManager'
export default {
  name: 'DocumentsList',
  components: { DocumentManager },
  mixins: [FileMixin],
  props: {
    isPublic: {type: Boolean, required: false, default: false}
  },
  data () {
    return {
      documents: [],
      showMore: false
    }
  },
  computed: {
    lastDocuments () {
      return this.documents.slice(0, 3)
    },
    lastDocumentsFormatted () {
      return this.lastDocuments.map(doc => ({
        ...doc,
        fileSizeFormatted: prettyBytes(doc.fileSize || 0),
        filePath: this.$_file_getDocumentPath(doc.id)
      }))
    }
  },
  async created () {
    this.documents = await DocumentRepository.fetchAll({isPublic: this.isPublic})
  }
}
</script>
